export interface UploadFileHistoryOverviewDto {
  id: string
  fileName: string
  dateCreated: string
  dateFinished: string
  recordsCreated: number
  failedRecords: number
  completedTransactions: number
  user: {
    id: string
    name: string
  }
}

export enum UploadFileHistoryOverviewKey {
  fileName = 'fileName',
  dateCreated = 'dateCreated',
  dateFinished = 'dateFinished',
  recordsCreated = 'recordsCreated',
  failedRecords = 'failedRecords',
  user = 'user.name',
}
